export default function ZodiacClashGlobalStyles() {
  return (
    <style>{`
@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes starDrift {
  from { background-position: 0 0, 17px 17px; }
  to { background-position: 700px 700px, 717px 717px; }
}

@keyframes toastPop {
  0% { opacity: 0; transform: translateX(-50%) translateY(18px) scale(.98); }
  12% { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
  88% { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
  100% { opacity: 0; transform: translateX(-50%) translateY(14px) scale(.98); }
}

@keyframes predictionChoicePulse {
  0% { transform: scale(1); }
  45% { transform: scale(1.035); }
  100% { transform: scale(1); }
}

@keyframes predictionHalo {
  0%,100% { opacity: .35; }
  50% { opacity: .9; }
}

.zdxTitle::before {
  content: '⚔️';
  display: block;
  font-size: 46px;
  line-height: 1;
  margin-bottom: 6px;
  filter: drop-shadow(0 0 10px rgba(218,165,32,.35));
}


@media (max-width: 720px) {
  .zdxQuestion::before,
  .zdxQuestion::after {
    display: none;
  }
}

@media (max-width: 620px) {
  .zdxTitle::before {
    font-size: 34px;
    margin-bottom: 4px;
  }

  .zdxCards {
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    justify-content: center !important;
    align-items: stretch !important;
    gap: 10px !important;
    width: 100% !important;
  }

  .zdxCard {
    width: calc(50vw - 22px) !important;
    min-height: 258px !important;
    border-radius: 24px !important;
  }

  .zdxCardInner {
    padding: 15px 8px !important;
  }

  .zdxQuestion {
    font-size: 20px !important;
    padding: 18px 16px 12px !important;
    margin-bottom: 8px !important;
  }

  .zdxTitle {
    font-size: 38px !important;
    letter-spacing: 1.2px !important;
  }
}

@media (max-width: 520px) {
  .zdxCards {
    gap: 9px !important;
  }

  .zdxCard {
    width: calc(50vw - 20px) !important;
    min-height: 242px !important;
  }

  .zdxCardInner {
    padding: 14px 6px !important;
  }
}

@media (max-width: 390px) {
  .zdxCard {
    width: calc(50vw - 18px) !important;
    min-height: 226px !important;
  }

  .zdxTitle {
    font-size: 34px !important;
  }

  .zdxQuestion {
    font-size: 18px !important;
  }
}

/* ===========================
   Dominion mobile fix
=========================== */

@media (max-width: 620px) {
  .zdxDominionGrid {
    display: flex !important;
    flex-direction: column !important;
    gap: 10px !important;
  }

  .zdxDominionCard {
    width: 100% !important;
    min-height: auto !important;
    padding: 12px 13px !important;
    display: grid !important;
    grid-template-columns: 42px minmax(0, 1fr) 48px !important;
    align-items: center !important;
    gap: 10px !important;
    box-sizing: border-box !important;
  }

  .zdxDominionLeft {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    min-width: 0 !important;
  }

  .zdxDominionRank {
    font-size: 20px !important;
    width: 42px !important;
    min-width: 42px !important;
    text-align: center !important;
    line-height: 1 !important;
  }

  .zdxDominionEmoji {
    font-size: 24px !important;
    min-width: 28px !important;
    line-height: 1 !important;
  }

  .zdxDominionInfo {
    min-width: 0 !important;
    overflow: hidden !important;
    align-items: flex-start !important;
    text-align: left !important;
  }

  .zdxDominionInfo > * {
    min-width: 0 !important;
    max-width: 100% !important;
  }

  .zdxDominionInfo span,
  .zdxDominionInfo div {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .zdxDominionPercent {
    font-size: 18px !important;
    text-align: right !important;
    min-width: 42px !important;
    line-height: 1 !important;
  }

  .zdxDominionBar {
    grid-column: 1 / -1 !important;
    width: 100% !important;
    margin-top: 2px !important;
    height: 8px !important;
  }
}

@media (max-width: 380px) {
  .zdxDominionCard {
    grid-template-columns: 38px minmax(0, 1fr) 42px !important;
    gap: 8px !important;
    padding: 11px 11px !important;
  }

  .zdxDominionRank {
    width: 38px !important;
    min-width: 38px !important;
    font-size: 18px !important;
  }

  .zdxDominionEmoji {
    font-size: 22px !important;
  }

  .zdxDominionPercent {
    font-size: 16px !important;
    min-width: 38px !important;
  }
}


/* ===========================
   Clash cards mobile perfect fit
   Evita que Cáncer / Acuario / Capricornio se corten
=========================== */

@media (max-width: 620px) {
  .zdxCards {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    justify-content: center !important;
    align-items: stretch !important;
    gap: 8px !important;
    width: 100% !important;
    padding: 0 4px !important;
    box-sizing: border-box !important;
    overflow: visible !important;
  }

  .zdxCard {
    flex: 0 0 calc((100vw - 92px) / 2) !important;
    width: calc((100vw - 92px) / 2) !important;
    max-width: 182px !important;
    min-width: 0 !important;
    min-height: 258px !important;
    box-sizing: border-box !important;
    overflow: visible !important;
  }

  .zdxCardInner {
    padding: 14px 6px !important;
    overflow: visible !important;
    min-width: 0 !important;
  }

  .zdxSignName {
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
    display: block !important;
    text-align: center !important;
    white-space: nowrap !important;
    overflow: visible !important;
    text-overflow: clip !important;
    font-size: clamp(19px, 5.7vw, 25px) !important;
    line-height: 1.04 !important;
    letter-spacing: -0.9px !important;
    transform: scaleX(0.94) !important;
    transform-origin: center center !important;
  }

  .zdxVsWrapper {
    flex: 0 0 44px !important;
    width: 44px !important;
    min-width: 44px !important;
    max-width: 44px !important;
    gap: 4px !important;
    margin: 96px -2px 0 -2px !important;
    z-index: 5 !important;
    pointer-events: none !important;
  }

  .zdxVsLine {
    width: 14px !important;
  }

  .zdxVsText {
    font-size: 31px !important;
    line-height: 1 !important;
  }
}

@media (max-width: 390px) {
  .zdxCard {
    flex-basis: calc((100vw - 82px) / 2) !important;
    width: calc((100vw - 82px) / 2) !important;
    min-height: 244px !important;
  }

  .zdxCardInner {
    padding: 13px 5px !important;
  }

  .zdxSignName {
    font-size: clamp(18px, 5.4vw, 23px) !important;
    letter-spacing: -1px !important;
    transform: scaleX(0.92) !important;
  }

  .zdxVsWrapper {
    flex-basis: 38px !important;
    width: 38px !important;
    min-width: 38px !important;
    max-width: 38px !important;
    margin-top: 92px !important;
  }

  .zdxVsText {
    font-size: 28px !important;
  }

  .zdxVsLine {
    width: 10px !important;
  }
}

@media (max-width: 350px) {
  .zdxCard {
    flex-basis: calc((100vw - 72px) / 2) !important;
    width: calc((100vw - 72px) / 2) !important;
  }

  .zdxSignName {
    font-size: 17px !important;
    transform: scaleX(0.90) !important;
  }

  .zdxVsWrapper {
    flex-basis: 34px !important;
    width: 34px !important;
    min-width: 34px !important;
    max-width: 34px !important;
  }
}


/* ===========================
   FINAL mobile card fit fix
   Cards adentro del viewport, sin corte lateral
=========================== */

@media (max-width: 620px) {
  .zdxCards {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    justify-content: center !important;
    align-items: stretch !important;
    gap: 6px !important;
    padding: 0 !important;
    box-sizing: border-box !important;
    overflow: visible !important;
  }

  .zdxCard {
    flex: 1 1 0 !important;
    width: auto !important;
    min-width: 0 !important;
    max-width: none !important;
    min-height: 250px !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
  }

  .zdxCardInner {
    padding: 14px 5px !important;
    min-width: 0 !important;
    box-sizing: border-box !important;
  }

  .zdxVsWrapper {
    flex: 0 0 42px !important;
    width: 42px !important;
    min-width: 42px !important;
    max-width: 42px !important;
    gap: 3px !important;
    margin: 94px 0 0 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
    z-index: 4 !important;
  }

  .zdxVsLine {
    width: 10px !important;
    min-width: 10px !important;
  }

  .zdxVsText {
    font-size: 28px !important;
    line-height: 1 !important;
  }

  .zdxSignName {
    width: 100% !important;
    max-width: 100% !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: clip !important;
    text-align: center !important;
    font-size: clamp(17px, 5.1vw, 23px) !important;
    line-height: 1.05 !important;
    letter-spacing: -1px !important;
    transform: scaleX(0.92) !important;
    transform-origin: center center !important;
  }
}

@media (max-width: 390px) {
  .zdxCards {
    gap: 5px !important;
  }

  .zdxCard {
    min-height: 238px !important;
  }

  .zdxVsWrapper {
    flex-basis: 36px !important;
    width: 36px !important;
    min-width: 36px !important;
    max-width: 36px !important;
    margin-top: 90px !important;
  }

  .zdxVsText {
    font-size: 25px !important;
  }

  .zdxVsLine {
    width: 8px !important;
    min-width: 8px !important;
  }

  .zdxSignName {
    font-size: clamp(16px, 4.9vw, 21px) !important;
    transform: scaleX(0.90) !important;
  }
}


@keyframes clashDecisivePulse {
  0%, 100% {
    box-shadow: 0 14px 32px rgba(0,0,0,.24),
                0 0 14px rgba(218,165,32,.08);
  }
  50% {
    box-shadow: 0 16px 36px rgba(0,0,0,.28),
                0 0 26px rgba(218,165,32,.18);
  }
}

.zdxRoundHeaderDecisive {
  animation: clashDecisivePulse 2.4s ease-in-out infinite;
}

.zdxRoundProgressFill {
  transform-origin: left center;
}

@media (max-width: 620px) {
  .zdxRoundHeader {
    width: 100% !important;
    margin-bottom: 12px !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  .zdxRoundHeaderDecisive {
    animation: none !important;
  }

  .zdxRoundProgressFill {
    transition: none !important;
  }
}


@media (max-width: 620px) {
  .zdxClashSummaryGrid {
    grid-template-columns: 1fr !important;
  }

  .zdxClashSummary {
    padding: 18px 14px !important;
  }
}


/* ===========================
   Clean Clash question area
=========================== */

.zdxQuestion::after {
  content: none !important;
  display: none !important;
}

.zdxQuestion {
  position: relative;
  isolation: isolate;
  overflow: hidden;
}

.zdxQuestion::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  display: block;
  background:
    radial-gradient(
      circle at 50% 0%,
      rgba(218,165,32,.09),
      transparent 46%
    ),
    linear-gradient(
      180deg,
      rgba(255,255,255,.022),
      transparent
    );
  pointer-events: none;
}

.zdxRoundHeader {
  position: relative;
  overflow: hidden;
}

.zdxRoundHeader::after {
  content: '';
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 0;
  height: 1px;
  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(218,165,32,.24),
      transparent
    );
  pointer-events: none;
}

@media (max-width: 620px) {
  .zdxRoundHeader {
    border-radius: 18px !important;
    padding: 13px 14px 14px !important;
  }

  .zdxQuestion {
    padding: 16px 15px !important;
    border-radius: 20px !important;
    font-size: clamp(18px, 5.4vw, 23px) !important;
    line-height: 1.3 !important;
  }
}


/* ===========================
   Premium Clash focus area
=========================== */

@media (max-width: 620px) {
  .zdxQuestion {
    width: 100% !important;
    padding: 18px 15px !important;
    font-size: clamp(20px, 6vw, 25px) !important;
    line-height: 1.3 !important;
  }

  .zdxVsText {
    width: 42px !important;
    height: 42px !important;
    font-size: 21px !important;
    flex: 0 0 42px !important;
  }
}


/* ===========================
   Clash result reveal
=========================== */

@keyframes clashResultReveal {
  0% {
    opacity: 0;
    transform: translateY(14px) scale(.985);
  }

  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes clashResultBarFill {
  0% {
    transform: scaleX(0);
  }

  100% {
    transform: scaleX(1);
  }
}

@keyframes clashWinnerPulse {
  0%, 100% {
    box-shadow:
      0 18px 40px rgba(0,0,0,.28),
      0 0 0 rgba(218,165,32,0);
  }

  50% {
    box-shadow:
      0 18px 40px rgba(0,0,0,.30),
      0 0 26px rgba(218,165,32,.13);
  }
}

.zdxResultReveal {
  animation:
    clashResultReveal
    420ms
    cubic-bezier(.2,.8,.2,1)
    both;
}

.zdxResultRevealHit {
  animation:
    clashResultReveal
    420ms
    cubic-bezier(.2,.8,.2,1)
    both,
    clashWinnerPulse
    2.2s
    ease-in-out
    420ms
    2;
}

.zdxResultProgressFill {
  transform-origin: left center;
  animation:
    clashResultBarFill
    720ms
    cubic-bezier(.2,.8,.2,1)
    120ms
    both;
}

@media (prefers-reduced-motion: reduce) {
  .zdxResultReveal,
  .zdxResultRevealHit,
  .zdxResultProgressFill {
    animation: none !important;
  }
}

    `}</style>
  );
}
